module.exports = __webpack_public_path__ + "media/MRI3A.ed35e49d.mp3";